import { render } from "./PhotoCarousel.vue?vue&type=template&id=052f1294&scoped=true"
import script from "./PhotoCarousel.vue?vue&type=script&lang=js"
export * from "./PhotoCarousel.vue?vue&type=script&lang=js"

import "./photo-carousel.scss?vue&type=style&index=0&id=052f1294&lang=scss&scoped=true"

import exportComponent from "/Users/balbeer.yadav/Development/lmthrm/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-052f1294"]])

export default __exports__